import { useEffect, useState } from "react";
import KeycloakContext from "./keycloakContext";
import { KeycloakService } from "./keycloakService";

const KeycloakProvider = ({ children }: { children: React.ReactNode }) => {
  const [keycloakService, setKeycloakService] =
    useState<KeycloakService | null>(null);
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    const service = new KeycloakService(setToken);
    setKeycloakService(service);

    service.init().catch((error) => {
      console.error("Keycloak initialization failed:", error);
    });
    return () => {
      service.clearTokenRefresh();
    };
  }, []);

  if (!keycloakService || !token) {
    return <div>Loading...</div>;
  }

  return (
    <KeycloakContext.Provider
      value={{
        keycloak: keycloakService.getKeycloakInstance(),
        token,
        cityId: keycloakService.getCityId() || "",
        logout: () => keycloakService.logout(),
        login: () => keycloakService.login(),
        createAccountUrl: () => keycloakService.createAccountUrl(),
        loggedIn: keycloakService.loggedIn(),
        authenticationService: keycloakService,
      }}
    >
      {children}
    </KeycloakContext.Provider>
  );
};

export default KeycloakProvider;
